import { FC, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import Constants from '../../../constants/constants';
import AuthService from '../../../services/auth/authService';
import AuthContext from '../../../context/AuthContext';
import { getToken } from '../../utils/getToken';

const HiddenIframe = styled.iframe`
  height: 1px;
  width: 1px;
  position: absolute;
  left: -9999px;
  top: 0;
  opacity: 0;
`;

const WebcoreIframePreloader: FC = () => {
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  const userLoggedIn = useSelector((state: any) => state.user.userLoggedIn);
  const keycloak = useContext(AuthContext);
  const [formattedUrl, setFormattedUrl] = useState<URL | null>(null);
  useEffect(() => {
    let cancelled = false;

    const buildUrl = async () => {
      if (!userLoggedIn) {
        setFormattedUrl(null);
        return;
      }

      const webcoreUrl = Constants.PLAY_CONTENT_URL;
      // Prefer the Keycloak token; fall back to the legacy localStorage token
      // only when there is no Keycloak session (see iframe-webcore.jsx).
      let token: string | null | undefined = null;
      try {
        token = await getToken(keycloak);
      } catch {
        token = AuthService.getAuthToken();
      }

      if (cancelled) {
        return;
      }

      setFormattedUrl(
        new URL(
          webcoreUrl.startsWith('http')
            ? webcoreUrl
            : `${window.location.protocol}${webcoreUrl}/service-worker-preload.html?auth=${token}`
        )
      );
    };

    buildUrl();

    return () => {
      cancelled = true;
    };
  }, [userLoggedIn, keycloak]);
  return formattedUrl ? <HiddenIframe src={`${formattedUrl}`} aria-hidden="true"></HiddenIframe> : <> </>;
};

export default WebcoreIframePreloader;
